import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-importerror',
  templateUrl: './importerror.component.html',
  styleUrls: ['./importerror.component.scss']
})

export class ImportErrorComponent implements OnInit {
  @Input() public cellData: any;
  @Input() public awbNo: string;
  @Input() public srNo: string;
  @Input() public activeTab: string;
  // dialogTitle: string;
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    // console.log("celldata",this.cellData);
    // this.dialogTitle = this.activeTab === 'awb'? `AWB No.: ${this.awbNo}`: `ODA Sr. No.: ${this.srNo}`;
    // this.dialogTitle =  `AWB No.: ${this.awbNo}`;
  }
}